module.exports = __webpack_public_path__ + "static/media/flobowling.244fd55f.svg";